module.exports = __webpack_public_path__ + "static/assets/55fa5e623772667c5a9f73efafe75fbb.png";